import React, { useEffect, useState } from "react";
import OtherIncomePage from "../../../../entities/DashboardPage/AccountingModule/OtherIncome";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";

const OtherIncome = () => {
  const [data, setData] = useState();
  const {showAlert} = useAlert();
  const [page, setPage] = useState(1)
  const [totalCount,setTotalCount] = useState();

  useEffect(() => {
    getOtherIncome()
  },[page])

  const getOtherIncome = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOtherIncome(page);
      if (result?.success) {
        setData(result?.data);
        setTotalCount(result?.data?.total)
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const deleteOtherIncome = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteOtherIncome(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getOtherIncome()
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  return(
    <>
      <OtherIncomePage deleteOtherIncome={deleteOtherIncome} page={page} setPage={setPage} totalCount={totalCount} setTotalCount={setTotalCount} data={data}/>
    </>
  )
}

export default OtherIncome